import styled from "../../../__compat__/styled-components/main.entry.mjs.mjs";
import { injectSpacing } from "../../../api/spacing/injectSpacing.mjs.mjs";
export const StyledDisclamerButton = styled.button.withConfig({ displayName: "auir-611444a-StyledDisclamerButton", componentId: "auir-611444a-1ora05m" }) `
  border: none;
  background: none;
  cursor: pointer;
  ${injectSpacing('margin')}
  path {
    transition: stroke 0.1s var(${(props) => props.theme.easing});
    stroke: var(${(props) => props.theme.colors.interaction.primary.default});
  }
  &:hover path {
    stroke: var(${(props) => props.theme.colors.interaction.primary.hover});
  }
  &:active path,
  &:focus path {
    stroke: var(${(props) => props.theme.colors.interaction.primary.active});
  }
`;
//# sourceMappingURL=ExtendedSelectionToolbarButton.styles.mjs.mjs.map